import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AdaptiveCard from "../components/AdaptiveCard";
import "../styles/AdaptiveLearning.scss";
import { getAllAdaptiveData } from "../helper/apicalls/adaptiveLearning";
import GlobalLoader from "../components/GlobalLoader";
import notAvailable from "../assets/images/notAvalaible.svg";

const AdaptiveLearning = () => {
  const navigate = useNavigate();
  const [allAdaptiveData, setAllAdaptiveData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getAdaptiveData();
  }, []);

  const adaptiveTopics = [];

  const getAdaptiveData = async () => {
    try {
      setLoading(true);
      const response = await getAllAdaptiveData();
      if (response) {
        const topics = response?.data?.map((item) => ({
          ...item,
          learning_context: item?.learning_context,
        }));
        setAllAdaptiveData(topics || []);
      }
    } catch (error) {
      console.error("Error fetching adaptive learning data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleCardClick = (topic) => {
    const topicId = topic.id || topic._id;
    if (!topicId) return;

    navigate(`/adaptive-learning/${topicId}`, {
      state: {
        id: topicId,
        page_type: topic.page_type,
        adaptive_status: topic.adaptive_status,
        completed: topic.completed,
        learning_context: topic.learning_context,
      },
    });
  };

  const getBreadcrumbPath = (learningContext = {}) => {
    const sequence = ["course", "subject", "topic", "subtopic"];
    const normalized = sequence
      .map((key) => {
        const node = learningContext[key];
        if (!node) return null;
        if (typeof node === "string") return node;
        return (
          node?.name || node?.title || node?.display_name || node?.course_name
        );
      })
      .filter(Boolean);
    return normalized.join(" > ");
  };

  const topicsToRender = allAdaptiveData.length
    ? allAdaptiveData
    : adaptiveTopics;

  return (
    <>
      {loading && <GlobalLoader />}
      <div className="adaptive-learning custom-scrollbar">
        <div className="adaptive-learning-content">
          {topicsToRender.length === 0 && !loading ? (
            <div className="not-found-container">
              <img
                src={notAvailable}
                alt="No Tasks"
                style={{ width: "300px", height: "300px", marginTop: "4px" }}
              />
              <h3>No Adaptive Learning Found!</h3>
            </div>
          ) : (
            <div className="adaptive-cards-container">
              {topicsToRender.map((topic) => {
                const breadcrumbText = topic.learning_context
                  ? getBreadcrumbPath(topic.learning_context)
                  : topic.breadcrumb || "";
                return (
                  <AdaptiveCard
                    key={topic.id}
                    title={topic.title}
                    breadcrumb={breadcrumbText}
                    completed={topic.completed}
                    status={topic.status || "active"}
                    onClick={() => handleCardClick(topic)}
                    onCtaClick={() => handleCardClick(topic)}
                    type={topic.page_type}
                  />
                );
              })}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default AdaptiveLearning;
